var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hotel_class"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_1244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_1244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotel_class_2",
    d: "M10.2976 24.7342C10.0873 24.9 9.86893 24.9068 9.64244 24.7547C9.41593 24.6026 9.34114 24.3966 9.41807 24.1368L11.0719 18.688L6.90524 15.688C6.67277 15.5273 6.59798 15.3171 6.68087 15.0572C6.76378 14.7974 6.94371 14.6675 7.22064 14.6675H12.4155L14.136 9.05725C14.1805 8.91365 14.251 8.80851 14.3476 8.74185C14.4442 8.67518 14.5506 8.64185 14.6668 8.64185C14.7831 8.64185 14.8895 8.67518 14.986 8.74185C15.0826 8.80851 15.1531 8.91365 15.1976 9.05725L16.9181 14.6675H22.113C22.3899 14.6675 22.5698 14.7974 22.6527 15.0572C22.7356 15.3171 22.6608 15.5273 22.4284 15.688L18.2617 18.688L19.9155 24.1368C19.9925 24.3966 19.9177 24.6026 19.6912 24.7547C19.4647 24.9068 19.2463 24.9 19.036 24.7342L14.6668 21.4265L10.2976 24.7342ZM11.4668 22.2008L14.6668 19.7598L17.8668 22.2008L16.6668 18.1342L19.6924 16.0008H15.9335L14.6668 11.8675L13.4001 16.0008H9.64117L12.6668 18.1342L11.4668 22.2008ZM23.2104 24.7342L22.7822 24.4137L21.354 19.729L24.8719 17.206H25.3976C25.0591 17.206 25.0779 17.3444 25.454 17.6213C25.8301 17.8983 25.9275 18.1 25.7463 18.2265L22.9232 20.2573L24.0976 24.1291C24.1574 24.3376 23.9574 24.4423 23.4976 24.4432C23.0378 24.444 22.9421 24.541 23.2104 24.7342ZM18.8924 12.0008L18.3283 10.1393L18.6514 9.08288C18.6959 8.93928 18.7664 8.83287 18.863 8.76365C18.9596 8.6944 19.066 8.65978 19.1822 8.65978C19.2985 8.65978 19.4049 8.69568 19.5014 8.76748C19.598 8.83928 19.6685 8.94441 19.713 9.08288L20.6155 12.0008H18.8924Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelClass);
export default __webpack_public_path__ + "static/media/hotel_class.d25176a4957047b9db5677e42564463f.svg";
export { ForwardRef as ReactComponent };